import { composeIO } from 'react-compose-io'
import { parametrosNotaFiscalIO } from './ParametrosNotaFiscal.IO'
import ParametrosNotaFiscalView from './ParametrosNotaFiscal.View'

export const ParametrosNotaFiscal = composeIO(ParametrosNotaFiscalView, parametrosNotaFiscalIO)
